import { createReducer } from "@reduxjs/toolkit";
import {
  ADMIN_ALL_USERS_FAIL,
  ADMIN_ALL_USERS_REQUEST,
  ADMIN_ALL_USERS_REQUEST_FAIL,
  ADMIN_ALL_USERS_SUCCESS,
  CREATE_ADDRESS_ERROR,
  CREATE_ADDRESS_REQUEST,
  CREATE_ADDRESS_REQUEST_FAIL,
  CREATE_ADDRESS_SUCCESS,
  DELETE_USER_ERROR,
  DELETE_USER_REQUEST,
  DELETE_USER_REQUEST_FAIL,
  DELETE_USER_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_REQUEST_FAIL,
  FORGOT_PASSWORD_SUCCESS,
  GET_USER_LOCATION,
  LIST_ADDRESS_ERROR,
  LIST_ADDRESS_REQUEST,
  LIST_ADDRESS_REQUEST_FAIL,
  LIST_ADDRESS_SUCCESS,
  LOGIN_USER_FAIL,
  LOGIN_USER_REQUEST,
  LOGIN_USER_REQUEST_FAIL,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_REQUEST,
  LOGOUT_USER_SUCCESS,
  TOKEN_VERIFY_FAIL,
  TOKEN_VERIFY_REQUEST,
  TOKEN_VERIFY_REQUEST_FAIL,
  TOKEN_VERIFY_SUCCESS,
  UPDATE_USER_PASSWORD_ERROR,
  UPDATE_USER_PASSWORD_FAIL,
  UPDATE_USER_PASSWORD_REQUEST,
  UPDATE_USER_PASSWORD_SUCCESS,
  UPDATE_USER_PROFILE_ERROR,
  UPDATE_USER_PROFILE_FAIL,
  UPDATE_USER_PROFILE_REQUEST,
  UPDATE_USER_PROFILE_SUCCESS,
  USER_SIGNUP_FAIL,
  USER_SIGNUP_REQUEST,
  USER_SIGNUP_REQUEST_FAIL,
  USER_SIGNUP_SUCCESS,
} from "../constant/User";

const initialState = {
  isAuthantication: false,
  adminloading: false,
  isLoading: false,
  user: {},
  AdminAllUser: [],
  userlocation: {},
  userAddress : []
};

export const UserReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(USER_SIGNUP_REQUEST, (state, action) => {
      state.isLoading = true;
    })
    .addCase(USER_SIGNUP_REQUEST_FAIL, (state, action) => {
      state.isLoading = false;
    })
    .addCase(USER_SIGNUP_SUCCESS, (state, action) => {
      state.isLoading = false;
    })
    .addCase(USER_SIGNUP_FAIL, (state, action) => {
      state.isLoading = false;
    })
    // --- login user
    .addCase(LOGIN_USER_REQUEST, (state, action) => {
      state.isLoading = true;
      state.isAuthantication = false;
    })
    .addCase(LOGIN_USER_REQUEST_FAIL, (state, action) => {
      state.isLoading = false;
      state.isAuthantication = false;
    })
    .addCase(LOGIN_USER_SUCCESS, (state, action) => {
      state.isLoading = false;
      state.isAuthantication = true;
      state.user = action.payload;
    })
    .addCase(LOGIN_USER_FAIL, (state, action) => {
      state.isLoading = false;
      state.isAuthantication = false;
    })
    // --- verify token
    .addCase(TOKEN_VERIFY_REQUEST, (state, action) => {
      state.isLoading = true;
      state.isAuthantication = false;
    })
    .addCase(TOKEN_VERIFY_REQUEST_FAIL, (state, action) => {
      state.isLoading = false;
      state.isAuthantication = false;
    })
    .addCase(TOKEN_VERIFY_SUCCESS, (state, action) => {
      state.isLoading = false;
      state.isAuthantication = true;
      state.user = action.payload;
    })
    .addCase(TOKEN_VERIFY_FAIL, (state, action) => {
      state.isLoading = false;
      state.isAuthantication = false;
    })
    // --- logout  the user
    .addCase(LOGOUT_USER_REQUEST, (state, action) => {
      state.isLoading = true;
      state.isAuthantication = true;
    })
    .addCase(LOGOUT_USER_SUCCESS, (state) => {
      state.isLoading = false;
      state.isAuthantication = false;
      state.user = {};
    })
    // ----- Admin All Users
    .addCase(ADMIN_ALL_USERS_REQUEST, (state) => {
      state.adminloading = true;
    })
    .addCase(ADMIN_ALL_USERS_REQUEST_FAIL, (state, action) => {
      state.adminloading = false;
    })
    .addCase(ADMIN_ALL_USERS_SUCCESS, (state, action) => {
      state.adminloading = false;
      state.AdminAllUser = action.payload;
    })
    .addCase(ADMIN_ALL_USERS_FAIL, (state, action) => {
      state.adminloading = false;
    })
    // --------------- update user profile
    .addCase(UPDATE_USER_PROFILE_REQUEST, (state, action) => {
      state.isLoading = true;
    })
    .addCase(UPDATE_USER_PROFILE_FAIL, (state) => {
      state.isLoading = false;
    })
    .addCase(UPDATE_USER_PROFILE_SUCCESS, (state) => {
      state.isLoading = false;
    })
    .addCase(UPDATE_USER_PROFILE_ERROR, (state) => {
      state.isLoading = false;
    })
    // ---- update user password
    .addCase(UPDATE_USER_PASSWORD_REQUEST, (state, action) => {
      state.isLoading = true;
    })
    .addCase(UPDATE_USER_PASSWORD_FAIL, (state) => {
      state.isLoading = false;
    })
    .addCase(UPDATE_USER_PASSWORD_SUCCESS, (state) => {
      state.isLoading = false;
    })
    .addCase(UPDATE_USER_PASSWORD_ERROR, (state) => {
      state.isLoading = false;
    })
    .addCase(GET_USER_LOCATION, (state, action) => {
      state.userlocation = action.payload;
    })
    // ---- delete user
    .addCase(DELETE_USER_REQUEST, (state) => {
      state.adminloading = true;
    })
    .addCase(DELETE_USER_REQUEST_FAIL, (state, action) => {
      state.adminloading = false;
    })
    .addCase(DELETE_USER_SUCCESS, (state, action) => {
      state.adminloading = false;
      state.AdminAllUser = action.payload;
    })
    .addCase(DELETE_USER_ERROR, (state, action) => {
      state.adminloading = false;
    })
    // ----- forgot password
    .addCase(FORGOT_PASSWORD_REQUEST, (state, action) => {
      state.isLoading = true;
    })
    .addCase(FORGOT_PASSWORD_REQUEST_FAIL, (state, action) => {
      state.isLoading = false;
    })
    .addCase(FORGOT_PASSWORD_SUCCESS, (state, action) => {
      state.isLoading = false;
    })
    .addCase(FORGOT_PASSWORD_ERROR, (state, action) => {
      state.isLoading = false;
    })

    // --- create user address 
    .addCase(CREATE_ADDRESS_REQUEST, (state, action) => {
      state.isLoading = true;
    })
    .addCase(CREATE_ADDRESS_REQUEST_FAIL, (state, action) => {
      state.isLoading = false;
    })
    .addCase(CREATE_ADDRESS_SUCCESS, (state, action) => {
      state.isLoading = false;
      state.userAddress.push(action.payload)
    })
    .addCase(CREATE_ADDRESS_ERROR, (state, action) => {
      state.isLoading = false;
    })

     // --- list user address 
     .addCase(LIST_ADDRESS_REQUEST, (state, action) => {
      state.isLoading = true;
    })
    .addCase(LIST_ADDRESS_REQUEST_FAIL, (state, action) => {
      state.isLoading = false;
    })
    .addCase(LIST_ADDRESS_SUCCESS, (state, action) => {
      state.isLoading = false;
      state.userAddress = action.payload
    })
    .addCase(LIST_ADDRESS_ERROR, (state, action) => {
      state.isLoading = false;
    })

});
